import request from '@/util/request';

// 评论-分页
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/social/circle/reply/page', Object.assign({}, options, { params }));

// 评论-显示|不显示
export const visibleApi = (params, options) =>
  request.post('/api/v4ward/social/circle/reply/update', params, options, {
    ContentType: 'application/json',
  });
